import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import getInvoice from 'assets/get-invoice-icon.png';
import noInvoice from 'assets/no-invoice-icon.png';
import { LanguageSwitcher } from 'components/language-switcher';
import { useLocale } from 'hooks';
import { useI18n } from 'locales';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import ReceiptSelectButton from './ReceiptSelectButton';

function EntrySelectPage({
  onSelect,
}) {
  const locale = useLocale();
  const t = useI18n();
  const onClickNoInvoice = useCallback(() => onSelect(false), [onSelect]);
  const onClickGetInvoice = useCallback(
    () => {
      window.location.href = `/?locale=${locale}`;
    }, [locale]
  );

  return (
    <Stack gap={3} className="w-full items-center justify-center min-h-screen" sx={{ position: 'relative' }}>
      <Stack direction="row" justifyContent="flex-end" sx={{ width: '100%', px: 2 }}>
        <LanguageSwitcher />
      </Stack>

      <Grid gap={{ xs: 3, sm: 6 }} sx={{ flexDirection: { xs: 'column', sm: 'row' }, display: 'flex', justifyContent: 'center', width: { xs: '100%', sm: '500px' } }}>
        <ReceiptSelectButton
          image={getInvoice}
          title={t('Require a receipt')}
          onClick={onClickGetInvoice}
        />

        <ReceiptSelectButton
          image={noInvoice}
          title={t('Do not require a receipt')}
          onClick={onClickNoInvoice}
        />
      </Grid>
    </Stack>
  );
}

EntrySelectPage.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

export default EntrySelectPage;
